import { useState, useEffect } from "react";
import "./ConfluencePicker.css";
import Modal from "../shared/Modal";
import { MSDrive } from "winslow-core";
import { selectUser } from "../../redux/features/appData";
import { useSelector } from "react-redux";
import { apiGetConfluenceSpaces } from "../../services/DriveService";

type ConfluencePickerProps = {
  isOpen: boolean;
  onClose: () => void;
  onSelected: (site: MSDrive | null) => void;
};

export const ConfluencePicker = ({
  isOpen,
  onClose,
  onSelected,
}: ConfluencePickerProps) => {
  const storeUser = useSelector(selectUser);

  const [confluenceSpaces, setConfluenceSpaces] = useState<MSDrive[] | null>(
    null
  );

  useEffect(() => {
    if (!confluenceSpaces && storeUser) {
      (async () => {
        const sites = await apiGetConfluenceSpaces(storeUser.id);
        setConfluenceSpaces(sites);
        if (!sites || sites.length === 0) {
          onSelected(null);
        }
      })();
    }
  }, []);

  console.log("[ConfluencePicker] sites: ", confluenceSpaces);

  return (
    <Modal
      isOpen={isOpen}
      style={null}
      onClose={onClose}
      canClose={false}
      allowClickout={true}>
      <div className="confluence-picker-container">
        {!confluenceSpaces && (
          <div className="confluence-loading">
            <div className="confluence-picker-logo">
              <img src="/icons/confluence.svg" alt="Confluence Logo" />
            </div>
            Loading Confluence spaces...
          </div>
        )}
        {confluenceSpaces && (
          <div className="confluence-picker-header">
            <div className="confluence-picker-title">
              Pick a Confluence Space
            </div>
            <div className="confluence-picker-buttons">
              <img className="icon-close" alt="" onClick={onClose} />
            </div>
          </div>
        )}

        <div className="confluence-picker-body">
          {confluenceSpaces &&
            confluenceSpaces.map((space: MSDrive) => {
              return (
                <div
                  key={"confluence-site-" + space.id}
                  className="confluence-picker-site"
                  onClick={() => onSelected(space)}>
                  <div className="confluence-picker-folder">
                    <img src="/icons/confluence.svg" alt="" />
                  </div>
                  <div className="confluence-picker-site-name">
                    {space.name}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </Modal>
  );
};
